<template>
  <v-dialog
    persistent
    transition="scale-transition"
    :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '300'"
    v-model="this._props.component.dialog_add"
  >
    <v-card outlined>
      <v-card-title class="text-subtitle-1 pa-3">Qual a quantidade?</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-3 pb-0">
        <v-form v-model="component.valid">
          <v-text-field
            outlined
            dense
            hide-details
            label="Quantidade"
            v-model="component.amount"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions
        class="pa-3"
        :style="$vuetify.breakpoint.xsOnly
          ? 'flex-direction: column; gap: 8px;'
          : 'justify-content: flex-end; gap: 8px;'"
      >
        <v-btn
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="red darken-4 white--text"
          @click="disableDialog"
        >Cancelar</v-btn>
        <v-btn
          :disabled="!component.valid"
          depressed
          :block="$vuetify.breakpoint.xsOnly"
          class="success"
          @click="component.AddDialogProductCar()"
        >Adicionar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    component: Object(),
  },
  methods: {
    disableDialog() {
      this.component.dialog_add = !this.component.dialog_add;
      this.component.amount = 1;
    },
    restartProductAmountAdd() {
      this.component.amount = 1;
    },
  },
  destroyed() {
    this.restartProductAmountAdd();
  },
};
</script>
